module.exports = __webpack_public_path__ + "static/25-988c8e12060e6492762a902ebac9c72a.png";